export default "__VITE_ASSET__9wI8SoeW__"